import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import SocialIcon from '../SocialIcon'
import { FB_SHARE_BASE_URL, TWITTER_SHARE_BASE_URL } from '../../constants'
import { breakpoints } from '../../styles/theme'

const SocialIconsWrapper = styled.div`
  padding-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${breakpoints.mobile} {
    flex-direction: row;

    > div {
      margin: 18px 20px;
    }
  }

  > div {
    margin-bottom: 20px;
  }
`

const BlogSocial = ({
  currentUrl,
  metaDescription,
  metaTitle,
  metaImageSrc,
}) => (
  <Fragment>
    <Helmet>
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImageSrc} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={currentUrl} />
      <meta property="fb:app_id" content="737511603285186" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@SMARTYMobileUK" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImageSrc} />
    </Helmet>
    <SocialIconsWrapper>
      <SocialIcon
        url={`${FB_SHARE_BASE_URL}${metaDescription}&u=${currentUrl}`}
        network="facebook"
        height="25px"
        width="25px"
      />
      <SocialIcon
        url={`${TWITTER_SHARE_BASE_URL}${metaDescription}&url=${currentUrl}`}
        network="twitter"
        height="25px"
        width="25px"
      />
    </SocialIconsWrapper>
  </Fragment>
)

export default BlogSocial
